/*
 * Sportsact: FAQ-søgning (sections/custom-faq.liquid).
 * Filtrerer spørgsmål (spørgsmål + svar) mens man skriver, skjuler tomme kategorier og viser en besked, når intet matcher.
 */
(() => {
  if (customElements.get('custom-faq')) return;

  const normalize = (text) => text.toLocaleLowerCase('da').normalize('NFKD').replace(/\s+/g, ' ').trim();

  class CustomFaq extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-faq-search]');
      this.items = Array.from(this.querySelectorAll('[data-faq-item]')).map((item) => ({ item, text: normalize(item.textContent) }));
      this.groups = Array.from(this.querySelectorAll('[data-faq-group]'));
      this.empty = this.querySelector('[data-faq-empty]');

      this.input?.addEventListener('input', () => this.filter(this.input.value));
    }

    filter(query) {
      const words = normalize(query).split(' ').filter(Boolean);
      let matches = 0;

      this.items.forEach(({ item, text }) => {
        const match = words.every((word) => text.includes(word));
        item.hidden = !match;
        if (match) matches++;
      });

      this.groups.forEach((group) => {
        group.hidden = !group.querySelector('[data-faq-item]:not([hidden])');
      });

      if (this.empty) this.empty.hidden = matches > 0;
    }
  }

  customElements.define('custom-faq', CustomFaq);
})();
